import { cn } from "@cloai/uikit";

export const STYLES = {
  base: "group/card @container bg-card relative flex w-full items-center gap-4 rounded-xl p-2",
  pointer: cn(
    "cursor-pointer duration-300",
    "hover:bg-[oklch(from_var(--color-card)_calc(l_+_0.1)_c_h)]",
    "active:scale-98 active:bg-[oklch(from_var(--color-card)_calc(l_+_0.05)_c_h)] active:duration-100",
  ),
  button:
    "absolute top-4 right-2 text-regular-foreground/50 opacity-0 duration-300 group-hover/card:opacity-100",
};
